import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/hrchy-config", params )
}

const getAllForCSV = params => {
  return restApi.post("/api/hrchy-configs/csv", params );
};

const getTopHrchy = params => {
  return restApi.get("/api/hrchy-config/top", { params })
}

const upsert = data => {
  return restApi.post("/api/hrchy-config/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/hrchy-configs/${ids}`);
};

const hrchyConfigService = {
  getAll,
  getAllForCSV,
  getTopHrchy,
  upsert,
  remove,
};

export default hrchyConfigService;